module.exports = __webpack_public_path__ + "img/tool.3fc04ee9.svg";